'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Glyph;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _group = require('@vx/group');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Glyph(_ref) {
  var _ref$top = _ref.top,
      top = _ref$top === undefined ? 0 : _ref$top,
      _ref$left = _ref.left,
      left = _ref$left === undefined ? 0 : _ref$left,
      className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    _group.Group,
    {
      className: (0, _classnames2.default)('vx-glyph', className),
      top: top,
      left: left
    },
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/glyph/build/glyphs/Glyph.js
// module id = 29
// module chunks = 0